import styled from 'styled-components';
import { AnnouncementsListItem } from "../Announcements.style";

export const NewsListItem = styled(AnnouncementsListItem)`
  grid-template-columns: 96px 1fr 2fr 12fr 1fr;
`;
